import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getTenantConfig } from "../Api";
import { handleRole } from "../Helper/handleRoleHelper";

const FeatureFlagContext = createContext();

const DEFAULT_FLAGS = { gcpEnabled: false, loading: true, error: null, refetchConfig: () => {} };

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);
  // Return safe defaults when used outside provider (e.g., public routes)
  if (!context) return DEFAULT_FLAGS;
  return context;
};

export const FeatureFlagProvider = ({ children }) => {
  const loginToken = useSelector((state) => state.reducer?.userToken);
  const loginDetail = useSelector((state) => state.reducer?.userLoggedIn);
  const [gcpEnabled, setGcpEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConfig = useCallback(async () => {
    if (!loginToken || !loginDetail?.role) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await getTenantConfig({
        loginToken,
        role: loginDetail.role,
      });
      if (response?.config) {
        setGcpEnabled(response.config.gcpEnabled || false);
      }
      setError(null);
    } catch (err) {
      console.error("Failed to fetch tenant config:", err);
      setError(err.message);
      setGcpEnabled(false);
    } finally {
      setLoading(false);
    }
  }, [loginToken, loginDetail?.role]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const value = {
    gcpEnabled,
    loading,
    error,
    refetchConfig: fetchConfig,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
